/**
 * "Geen toegang" voor een prijsanalist die een beheerdersscherm opent (US-002, US-030).
 *
 * Bewust een kaart in het scherm en geen doorverwijzing: de gebruiker ziet dan dat het scherm
 * bestaat maar niet voor hem is, in plaats van onverwacht ergens anders te belanden.
 */

import styles from './NoAccessScreen.module.css';

export function NoAccessScreen(): React.JSX.Element {
  return (
    <div className={styles.page}>
      <div className={styles.denied} role="alert">
        <div className={styles.deniedTitle}>Geen toegang</div>
        <p className={styles.text}>
          Dit scherm is alleen beschikbaar voor beheerders. Vraag een beheerder om hulp wanneer u
          hier iets moet aanpassen.
        </p>
      </div>
    </div>
  );
}
